export const stockFormOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    submitBtn: false,
    emptyBtn: false,
    addBtn: false,
    menu: false,
    columnBtn: false,
    refreshBtn: false,
    searchBtn: false,
    header: false,
    width: "50%",
    border: true,
    menuWidth: '300',
    labelWidth: '150',
    column: [
      {
        label: "商品名称",
        type: "input",
        span: 13,
        prop: "name"
      },
      {
        label: "商品单位",
        span: 13,
        type: "input",
        prop: "unit"
      },
    ]
  };
  